import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';

import { ActiveMenuDirective } from './layouts/navbar/active-menu.directive';
import { AppRoutingModule } from './app-routing.module';
import { ArrowIconComponent } from './shared/components/arrow/arrow-icon.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ButtonModule } from './shared/components/button/button.module';
import { ChangePasswordDialogComponent } from './layouts/topbar/change-password-dialog/change-password-dialog.component';
import { CoreModule } from './core/core.module';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { EntitiesModule } from './entities/entities.module';
import { EntityBaseComponent } from './ids/base/entity-base.component';
import { ErrorComponent } from './layouts/error/error.component';
import { EventDialogComponent } from './booking/calendar-for-an-individual-resource/event-dialog/event-dialog.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { HomeModule } from './home/home.module';
import { IdsCompanyModalComponent } from './shared/components/company/company-modal.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MainComponent } from './layouts/main/main.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { PageRibbonComponent } from './layouts/profiles/page-ribbon.component';
import { PaymentTypeDialogComponent } from './entities/card-extension/payment-type-dialog/payment-type-dialog.component';
import { SharedModule } from './shared/shared.module';
import { ToastModule } from 'primeng/toast';
import { TopbarComponent } from './layouts/topbar/topbar.component';
import { TranslateService } from '@ngx-translate/core';
import { createMatPaginatorIntl } from './shared/MdPaginator';
import { HttpClientModule } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    CoreModule,
    HomeModule,
    EntitiesModule,
    AppRoutingModule,
    MatProgressSpinnerModule,
    ToastModule,
    ArrowIconComponent,
    ButtonModule,
    HttpClientModule
  ],
  declarations: [
    MainComponent,
    TopbarComponent,
    ChangePasswordDialogComponent,
    NavbarComponent,
    ErrorComponent,
    PageRibbonComponent,
    ActiveMenuDirective,
    FooterComponent,
    PaymentTypeDialogComponent,
    EntityBaseComponent, // IDS
    IdsCompanyModalComponent,
    EventDialogComponent,
  ],
  providers: [
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'sr-RS' },
    {
      provide: MatPaginatorIntl,
      useFactory: createMatPaginatorIntl,
      deps: [TranslateService],
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: ['modal-above-topbar', 'dialog-container'],
        hasBackdrop: true,
        backdropClass: 'modal-backdrop-above',
        autoFocus: true,
        disableClose: false
      } as MatDialogConfig,
    },
  ],
  bootstrap: [MainComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
